import styled from 'styled-components';

export const PlayerWrapper = styled.div`
  display: flex;
  flex-flow: column nowrap;
  flex-grow: 1;
  background: ${(props) => props.theme.background};
`;

export const PlayerHeader = styled.div`
  position: sticky;
  top: 0;
  left: 0;
  background: ${({ theme }) => theme.background};
  z-index: 150;
  display: flex;
  flex: 0 0 80px;
  box-shadow: 0 1px 15px 0 ${({ theme }) => theme.headerShadowColor};
`;

export const SubControlsWrapper = styled.div`
  display: flex;
  flex-flow: column nowrap;
  flex: 1 1 auto;
  width: calc(100% - 80px);
`;

export const TrackControlsWrapper = styled.div`
  display: flex;
  align-items: center;
`;
